/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class NoticeRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      // Not including comments/reactions as they're not enabled.
      post: this.store.findRecord('posts/globalnotice', params.post_id),
    });
  }
}
